import { TitleCasePipe } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ProductPublicModels } from '@features/products/product';

@Component({
    selector: 'product-color-info',
    templateUrl: './product-color-info.component.html',
    standalone: true,
    imports: [ TranslateModule, TitleCasePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductColorInfoComponent {
    @Input() public selectedColor: ProductPublicModels.PublicProductColor;

    @Input() public isHexadecimalColors = false;

    @Input() public isCustomizationColor = false;

    @Input() public textPosition = 'none';

    @Input() public textAlign = 'center';

    @Input() public displayReference: string;
}
